
import Data from "../../../assets/outline/Data.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DataIcon({ className, dataTestid = "DataIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Data data-testid={dataTestid} className={classes} {...rest} />
  );
}
